import React, { useContext, useEffect, useState } from "react";
import useFetch from "../../Hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { classesURL, schoolListURL, teacherListURL } from "../../Hooks/URL";
import Classes from "../../Templates/Classes/Classes";
import { userContext } from "../../Contexts/userContext";

function ClassesPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(9);
  const [totalCount, setTotalCount] = useState(0);
  const [searchData, setSearchData] = useState("");
  const [search, setSearch] = useState("");
  const [Filter, setFilter] = useState("");
  const [sort, setSort] = useState("&sortBy=startDate&sortDesc=true");

  const [classes, setClasses] = useState([]);

  const { data, loading, error } = useFetch(
    classesURL,
    page,
    rowsPerPage,
    search,
    null,
    false,
    `${sort}${Filter}`
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setClasses(data?.data?.data?.rows);
      setPageCount(data?.data?.data?.numberOfPages);
      setTotalCount(data?.data?.data?.totalCount);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "classes", data: "" });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Classes
      role={contextData?.role}
      page={page}
      searchData={searchData}
      search={search}
      setSearchData={setSearchData}
      setSearch={setSearch}
      classes={classes}
      navigate={navigate}
      handleChangePage={handleChangePage}
      loading={loading}
      data={data}
      error={error}
      pageCount={pageCount}
      setClasses={setClasses}
      setFilter={setFilter}
      totalCount={totalCount}
      setRowsPerPage={setRowsPerPage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      setSort={setSort}
      currentSort={sort}
    />
  );
}

export default ClassesPage;
